export default __webpack_public_path__ + "media/images/promare/promare5-4b232a225c7eae2243c79bd6fe7ad18d.jpg";